import recommendationsModule from '../recommendationsModule.js';

function recommendationsController(
  $rootScope,
  recommendationsService,
  recommendationsConstants,
  $log,
  itemsListService,
  urlService,
  itemListConstants,
  itemsListLayoutService,
  $scope
) {
  'ngInject';

  const ctrl = this;
  const library = {
    currentPageName: null,
    isMetaDataLoaded: false
  };

  ctrl.dismissPlaceholderForRecommendation = function () {
    $rootScope.isPlaceholderOff = true;

    // TODO: FOR ROLLOUT FALLBACK so web release and webapps release can be independent
    $rootScope.isRecommendationsLoaded = true;
  };

  function checkMoreByCreatorAvailability() {
    ctrl.isMoreByCreatorEnabled =
      ctrl.itemCreator && Object.prototype.hasOwnProperty.call(ctrl.itemCreator, 'Id');
    $scope.itemCreator = ctrl.itemCreator;
  }

  const initRecommendations = () => {
    const { recommendationSubtype, recommendationType, recommendationItemtypes, pageName } = ctrl;
    recommendationsService.overrideRecommendationTypes(recommendationItemtypes);
    if (recommendationsService.isRecommendationAllowed(recommendationType, recommendationSubtype)) {
      if (library.currentPageName !== pageName) {
        ctrl.absoluteCatalogUrl = urlService.getAbsoluteUrl(recommendationsConstants.urls.catalog);

        if (!ctrl.recommendationTargetId) {
          ctrl.recommendationTargetId = 0;
        }

        library.currentPageName = pageName;
        recommendationsService.getRecommendationMetadata(pageName).then(
          function success(recommendationsMetadata) {
            Object.assign(ctrl, recommendationsMetadata);
            ctrl.isV2EndpointEnabled = recommendationsMetadata.isV2EndpointEnabled;

            recommendationsService.getCatalogMetadata().then(
              function success(catalogMetadata) {
                library.isPremiumIconOnItemTilesEnabled =
                  catalogMetadata.isPremiumIconOnItemTilesEnabled;
                library.isPremiumPriceOnItemTilesEnabled =
                  catalogMetadata.isPremiumPriceOnItemTilesEnabled;
                library.isMetaDataLoaded = true;
                if (ctrl.numberOfItems) {
                  ctrl.getItems();
                }
              },
              function error() {
                $log.debug(' ------ getCatalogMetadata error -------');
                ctrl.dismissPlaceholderForRecommendation();
              }
            );
          },
          function error() {
            $log.debug(' ------ getRecommendationsMetadata error -------');
            ctrl.dismissPlaceholderForRecommendation();
          }
        );
      } else if (library.isMetaDataLoaded && ctrl.numberOfItems) {
        ctrl.getItems();
      }
    } else {
      ctrl.clearItems();
    }

    ctrl.dismissPlaceholderForRecommendation();
  };

  ctrl.clearItems = () => {
    ctrl.items = [];
  };

  ctrl.getItems = () => {
    ctrl.items = [];
    const {
      recommendationTargetId,
      recommendationType,
      recommendationSubtype,
      numberOfItems,
      subject,
      isV2EndpointEnabled
    } = ctrl;
    recommendationsService
      .beginUpdateRecommendedItems(
        recommendationTargetId,
        recommendationType,
        recommendationSubtype,
        numberOfItems,
        subject,
        isV2EndpointEnabled
      )
      .then(
        result => {
          ctrl.items = result;
        },
        () => {
          $log.debug(' ------ beginUpdateRecommendedItems error -------');
        }
      )
      .finally(() => {
        ctrl.dismissPlaceholderForRecommendation();
      });
  };

  function doesItemHavePremiumPrice(item) {
    return item.premiumPrice !== undefined && item.premiumPrice !== null;
  }

  ctrl.getDisplayPrice = item => {
    if (library.isPremiumPriceOnItemTilesEnabled && doesItemHavePremiumPrice(item)) {
      return item.premiumPrice;
    }

    return item.price;
  };

  ctrl.shouldShowPremiumIcon = item => {
    return library.isPremiumIconOnItemTilesEnabled && doesItemHavePremiumPrice(item);
  };

  const initialized = () => {
    initRecommendations();
    checkMoreByCreatorAvailability();
  };

  ctrl.$onInit = initialized;

  $scope.$watch(
    () => {
      return {
        recommendationType: ctrl.recommendationType,
        recommendationSubtype: ctrl.recommendationSubtype
      };
    },
    (newVals, oldVals) => {
      if (
        (typeof oldVals.recommendationType === 'number' &&
          newVals.recommendationType !== oldVals.recommendationType) ||
        (typeof oldVals.recommendationSubtype === 'number' &&
          newVals.recommendationSubtype !== oldVals.recommendationSubtype)
      ) {
        initRecommendations();
      }
    },
    true
  );
}

recommendationsModule.controller('recommendationsController', recommendationsController);
export default recommendationsController;
